import { themeColors } from '@/theme/colors';

type SummaryTableCellProps = {
  topValue: string | number;
  bottomValue: string | number;
  isHeading?: boolean;
};

const SummaryTableCell = ({
  topValue,
  bottomValue,
  isHeading = false,
}: SummaryTableCellProps) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '8px',
        borderBottom: `1px solid ${themeColors.stroke.subtle}`,
        height: '72px',
      }}
    >
      <span className={isHeading ? 'heading-md' : 'body-md-medium'}>
        {topValue}
      </span>
      <span
        className="label-xs-regular"
        style={{ color: themeColors.content.subtle }}
      >
        {bottomValue}
      </span>
    </div>
  );
};
export default SummaryTableCell;
